// extracted by mini-css-extract-plugin
module.exports = {"description":"description__vWPHk","descriptionButton":"descriptionButton__30A9T"};